import { Image } from 'expo-image'
import React from 'react'
import { View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { card } from '@ui-kit/components/cards/Card/styles'
import type { NativeProps } from '@ui-kit/components/cards/Card/types'
import { bgColor, borderColor } from '@ui-kit/styles/colors'
import { paddingX, paddingY } from '@ui-kit/styles/padding'

const Card = (props: NativeProps) => {
  const {
    bgColor: bgColorProp,
    bgImage: bgImageProp,
    borderColor: borderColorProp,
    verticalPadding: verticalPaddingProp,
    horizontalPadding: horizontalPaddingProp,
    className,
    ...viewProps
  } = props
  const { container, bgImage } = card({
    borderless: borderColorProp === 'none',
  })
  return (
    <View
      {...viewProps}
      className={twMerge(
        container(),
        bgColorProp && bgColor({ color: bgColorProp }),
        borderColorProp !== 'none' &&
          borderColor({
            color: borderColorProp ?? bgColorProp ?? 'uiGreyLight',
          }),
        verticalPaddingProp && paddingY({ space: verticalPaddingProp }),
        horizontalPaddingProp && paddingX({ space: horizontalPaddingProp }),
        className
      )}
    >
      {bgImageProp ? <Image className={bgImage()} source={bgImageProp} /> : null}
      {props.children}
    </View>
  )
}

export default Card
